var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-modal',{attrs:{"modal-id":_vm.modalId,"action-primary":_vm.$options.primaryAction,"action-cancel":_vm.$options.cancelAction,"title":_vm.$options.CANCEL_JOBS_MODAL_TITLE},on:{"primary":_vm.onSubmit}},[_vm._v("\n  "+_vm._s(_vm.$options.CANCEL_JOBS_WARNING)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }